import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRemove = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 22,
	viewBox: "0 0 21 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_115_2941)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M10.5 21.4329C16.0228 21.4329 20.5 16.9557 20.5 11.4329C20.5 5.91001 16.0228 1.43286 10.5 1.43286C4.97715 1.43286 0.5 5.91001 0.5 11.4329C0.5 16.9557 4.97715 21.4329 10.5 21.4329Z",
				fill: "#001E50",
				stroke: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.4257 8.11486C17.0115 7.52907 17.0115 6.57933 16.4257 5.99354C15.8399 5.40775 14.8901 5.40775 14.3043 5.99354L5.06092 15.2369C4.47514 15.8227 4.47514 16.7725 5.06092 17.3582C5.64671 17.944 6.59646 17.944 7.18224 17.3582L16.4257 8.11486Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.18175 5.99353C6.59597 5.40775 5.64622 5.40775 5.06043 5.99353C4.47465 6.57932 4.47465 7.52907 5.06043 8.11485L14.072 17.1265C14.6578 17.7123 15.6076 17.7123 16.1934 17.1265C16.7792 16.5407 16.7792 15.591 16.1934 15.0052L7.18175 5.99353Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_115_2941",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 21,
			height: 22,
			fill: "white"
		})
	}) })]
});
export default SvgRemove;
